export const TRIAL_PAGES_MATRIX = 'matrix';
